const setJSON = (key, value) => {
  try {
    if (value === undefined) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[storage] Failed to set item', { key, error: err });
  }
};

const getJSON = (key, defaultValue = null) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return defaultValue;
    return JSON.parse(raw);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[storage] Failed to parse item', { key, error: err });
    return defaultValue;
  }
};

const remove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[storage] Failed to remove item', { key, error: err });
  }
};

export default {
  setJSON,
  getJSON,
  remove,
};
